import { unsaltData } from "./salt";
export const getData = (document) => {
    return unsaltData(document.data);
};
